<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconOpenInNew_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M1.589 1.009A1 1 0 0 1 1.7 1h3.5a.7.7 0 1 1 0 1.4H2.4v11.2h11.2v-2.8a.7.7 0 1 1 1.4 0v3.5a.7.7 0 0 1-.7.7H1.7a.7.7 0 0 1-.7-.7V1.7a.7.7 0 0 1 .589-.691"
    />
    <path
        fill="currentColor"
        d="M14.398 1H7.977a.601.601 0 0 0-.192 1.172l3.543 1.19-4.53 4.531a.926.926 0 0 0 1.308 1.31l4.53-4.531 1.192 3.544A.601.601 0 0 0 15 8.024V1.602A.6.6 0 0 0 14.398 1"
    />
</svg>
